import React from 'react';
import styles from './styles.module.scss';

export interface CheckboxLabelProps {
  children: React.ReactNode;
  readOnly?: boolean;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
}

export const CheckboxLabel = ({
  children,
  readOnly = false,
  checked,
  onChange,
}: CheckboxLabelProps): React.ReactElement => {
  return (
    <label className={styles.checkboxLabel}>
      {readOnly ? (
        <input type="checkbox" defaultChecked readOnly />
      ) : (
        <input type="checkbox" checked={checked} onChange={(e) => onChange?.(e.target.checked)} />
      )}
      <span>{children}</span>
    </label>
  );
};
